import { render, staticRenderFns } from "./ProfileBaseView.vue?vue&type=template&id=82b9fcfa&"
import script from "./ProfileBaseView.vue?vue&type=script&lang=ts&"
export * from "./ProfileBaseView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports